// extracted by mini-css-extract-plugin
export default {"pageWrapper":"src-constrains-SalesChannelContentWrapperRevamp-css-module__pageWrapper--VJKne","header":"src-constrains-SalesChannelContentWrapperRevamp-css-module__header--41MmI"};